import styled from 'styled-components';

// material ui
import {
  List, ListSubheader, Menu as MuiMenu, Badge,
} from '@material-ui/core';

export const Sidebar = styled.aside <{width: string}>`
    position: fixed;
    top: 0;
    bottom: 0;
    width: ${props => props.width};
    height: 100%;
    color: ${props => props.theme.menu.color};
    background: ${props => props.theme.menu.background};
    overflow-x: hidden;
    overflow-y: auto;
`;
export const SidebarHeader = styled.div`
    
    padding: 0 ${props => props.theme.spacing(2)}px;
    ${props => props.theme.mixins.toolbar};
`;

export const NavList = styled(List)`
    width: ${props => props.theme.menu.width}px;
    font-size: 1.1em;
    font-weight: 400;
    line-height: 1.5px;
    letter-spacing: 0.00938em;
`;
export const NavListHeader = styled(ListSubheader)`
    text-align: center;
`;

export const Menu = styled(MuiMenu)`
    > .MuiMenu-paper {
      left: 60px !important;
    }
`;
export const MenuBadge = styled(Badge)`
    > div {
      margin-top: 10px;
    }
    > span.MuiBadge-badge {
      position: relative;
      top: 10px;
    }
`;